import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useAtom } from 'jotai'
import userClient from '../../Api/Lirari/Clients/userClient'
import { myUserAtom } from '../../State/Musician/myUserAtom'
import { genresAtom } from '../../State/Musician/genresAtom'
import genreClient from '../../Api/Lirari/Clients/genreClient'
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { Login, Logout, Person } from '@mui/icons-material'
import { offeringsAtom } from '../../State/Musician/offeringsAtom'
import offeringClient from '../../Api/Lirari/Clients/offeringClient'
import { isEmailBeingVerifiedAtom } from '../../State/Musician/isEmailBeingVerifiedAtom'

const MobileBurgerMenu = () => {
  const navigate = useNavigate()
  const path = useLocation().pathname
  const { logout, isAuthenticated, getAccessTokenSilently, user } = useAuth0()
  const [myUser, setMyUser] = useAtom(myUserAtom)
  const theme = useTheme()
  const [isEmailBeingVerified] = useAtom(isEmailBeingVerifiedAtom)

  const [, setGenres] = useAtom(genresAtom)
  const [, setOfferings] = useAtom(offeringsAtom)
  const [menuOpen, setMenuOpen] = useState(false)

  React.useEffect(() => {
    ;(async () => {
      if (isAuthenticated && user?.sub) {
        // Check if email is verified
        if (!user.email_verified && !isEmailBeingVerified) {
          navigate('/verify-email')
          return
        }

        const token = await getAccessTokenSilently({
          authorizationParams: {
            scope: 'user:all',
          },
        })

        const lirariUser = await userClient.getUserByAuth0Id(user.sub, token)
        if (!lirariUser) {
          return
        }

        setMyUser({
          id: lirariUser.id,
          auth0Id: lirariUser.auth0Id,
          firstName: lirariUser.firstName,
          lastName: lirariUser.lastName,
          email: lirariUser.email,
          about: lirariUser.about,
          locationFormattedString: lirariUser.locationFormattedString,
          socialLinks: {
            youtube: lirariUser.youTubeUrl,
            spotify: lirariUser.spotifyUrl,
            soundCloud: lirariUser.soundCloudUrl,
          },
          userGenres: lirariUser.userGenres ?? [],
          userSkills: lirariUser.userSkills ?? [],
          userOfferings: lirariUser.userOfferings ?? [],
          profileImageUrl:
            lirariUser.profileImageUrl ||
            'https://storage.googleapis.com/demo-profile/images/the-musician-unblurred.png',
          portfolioLinks: lirariUser.portfolioLinks ?? [],
          profileAudioUrl:
            lirariUser.profileAudioUrl || 'https://storage.googleapis.com/demo-profile/audio/Wartime%204.3.m4a',
        })
      }
    })()
  }, [
    isAuthenticated,
    user?.sub,
    getAccessTokenSilently,
    setMyUser,
    navigate,
    user?.email_verified,
    isEmailBeingVerified,
  ])

  React.useEffect(() => {
    ;(async () => {
      const genres = await genreClient.getGenres()
      setGenres(genres)
    })()
  }, [setGenres])

  React.useEffect(() => {
    ;(async () => {
      const offerings = await offeringClient.getOfferings()
      setOfferings(offerings)
    })()
  }, [setOfferings])

  const DrawerList = (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        width: 250,
        height: '100%',
      }}
      role="presentation"
      onClick={() => setMenuOpen(false)}
    >
      <List>
        {path !== '/example-profile' ? (
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="Example Profile" onClick={() => navigate('/example-profile')} />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}
        {isAuthenticated && path !== `/u/${myUser.id}` ? (
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="My Profile" onClick={() => navigate(`/u/${myUser.id}`)} />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}
        {isAuthenticated && path !== `/search` ? (
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="Search" onClick={() => navigate(`/search`)} />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}
        {isAuthenticated ? (
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}
        {!isAuthenticated ? (
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Login />
              </ListItemIcon>
              <ListItemText primary="Login" onClick={() => navigate('/login')} />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}
      </List>
    </Box>
  )

  return (
    <div className="lg:hidden flex pr-3">
      <button onClick={() => setMenuOpen(true)}>
        <MenuIcon></MenuIcon>
      </button>
      <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>
        {DrawerList}
      </Drawer>
    </div>
  )
}

export default MobileBurgerMenu
